module.exports = __webpack_public_path__ + "img/corchete-azul-11.b8a2db6f.svg";